export function DashboardStats({ stats }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4 mb-8">
      <div className="admin-card" data-testid="stat-total">
        <p className="text-sm text-healing-burgundy-light mb-1">Total</p>
        <p className="text-2xl font-heading text-healing-burgundy">{stats.total}</p>
      </div>
      <div className="admin-card" data-testid="stat-pending">
        <p className="text-sm text-healing-burgundy-light mb-1">Pending</p>
        <p className="text-2xl font-heading text-yellow-600">{stats.pending}</p>
      </div>
      <div className="admin-card" data-testid="stat-confirmed">
        <p className="text-sm text-healing-burgundy-light mb-1">Confirmed</p>
        <p className="text-2xl font-heading text-green-600">{stats.confirmed}</p>
      </div>
      <div className="admin-card" data-testid="stat-completed">
        <p className="text-sm text-healing-burgundy-light mb-1">Completed</p>
        <p className="text-2xl font-heading text-blue-600">{stats.completed}</p>
      </div>
      <div className="admin-card" data-testid="stat-cancelled">
        <p className="text-sm text-healing-burgundy-light mb-1">Cancelled</p>
        <p className="text-2xl font-heading text-red-600">{stats.cancelled}</p>
      </div>
      <div className="admin-card bg-emerald-50" data-testid="stat-revenue">
        <p className="text-sm text-emerald-700 mb-1">Revenue</p>
        <p className="text-2xl font-heading text-emerald-600">${stats.revenue}</p>
      </div>
      <div className="admin-card bg-orange-50" data-testid="stat-pending-revenue">
        <p className="text-sm text-orange-700 mb-1">Pending $</p>
        <p className="text-2xl font-heading text-orange-600">${stats.pending_revenue}</p>
      </div>
    </div>
  );
}
